import React from 'react';
import { createUseStyles, Text, Icon } from '@Sage/hoi-poi-ui';
import { useWeb5Context } from 'lib/Web5Context';

import styles from './styles';
const useStyles = createUseStyles(styles, 'CopilotWidgetHeader');

const CopilotWidgetHeader = ({ onClose }) => {
    const { t } = useWeb5Context();
    const classes = useStyles();
    return (
        <div className={classes.root}>
            <Text type="h4" color="black">
                {t('label_copilot_title')}
            </Text>
            <Icon name="close" onClick={onClose} size="large" className={classes.closeIcon} />
        </div>
    );
};

export default CopilotWidgetHeader;
